// Reads the file name from a Content-Disposition header, e.g.
// `attachment; filename="Facility_Report_20261102.csv"` or `filename*=UTF-8''...`
export const getFileNameFromDisposition = disposition => {
  if (!disposition) return null;
  const encoded = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim().replace(/"/g, ''));
    } catch (e) {
      // fall through to the plain filename
    }
  }
  const plain = disposition.match(/filename="?([^";]+)"?/i);
  return plain ? plain[1].trim() : null;
};

// Saves a blob axios response as a file, using the server-provided name when present
export const downloadFile = (response, fallbackName) => {
  const fileName =
    getFileNameFromDisposition(response.headers?.['content-disposition']) || fallbackName;
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  return fileName;
};
